import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import useAuthCheck from "./hooks/useAuthCheck";
import Assigments from "./pages/Assigments";
import AssignmentMarks from "./pages/AssignmentMarks";
import CoursePlayer from "./pages/CoursePlayer";
import Dashboard from "./pages/Dashboard";
import LeaderBoard from "./pages/LeaderBoard";
import Login from "./pages/Login";
import Quizzes from "./pages/Quizzes";
import Register from "./pages/Register";
import StudentQuizz from "./pages/StudentQuizz";
import Videos from "./pages/Videos";


function App() {
    const authChecked = useAuthCheck();

    return !authChecked ? (
        <div className="text-center">Checking authentication....</div>
    ) : (
        <Router>
            <Routes>
                <Route
                    path="/"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/register"
                    element={
                        <PublicRoute>
                            <Register />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/course-player"
                    element={
                        <PrivateRoute>
                            <CoursePlayer />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/student-quizz"
                    element={
                        <PrivateRoute>
                            <StudentQuizz />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/leaderboard"
                    element={
                        <PrivateRoute>
                            <LeaderBoard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/admin"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/admin/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/admin/videos"
                    element={
                        <PrivateRoute>
                            <Videos />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/admin/assignments"
                    element={
                        <PrivateRoute>
                            <Assigments />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/admin/quizzes"
                    element={
                        <PrivateRoute>
                            <Quizzes />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/admin/assignment-mark"
                    element={
                        <PrivateRoute>
                            <AssignmentMarks />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
